import { environment } from "@edp-environments/environment";
import { RegionService } from "./region.service";
import { RegionEnum } from "@edp-enums/region.enum";
import { Injectable } from "@angular/core";

interface IEnvFirebase {
    apiKey: string;
    authDomain: string;
    databaseURL: string;
    projectId: string;
    storageBucket?: string;
    messagingSenderId?: string;
}

const domainCookie = {
    PT: "edp.pt",
    ES: "edpenergia.es",
};

const domain = {
    PT: "edp.pt",
    ES: "edpenergia.es",
};

@Injectable({
    providedIn: "root",
})
export class EnvService {
    private region: RegionEnum;

    constructor(private regionService: RegionService) {
        this.region = this.regionService.getRegion();
    }

    public originUrl(): string {
        return window.location.origin;
    }

    public ssoUrl(): string {
        return environment.ssoUrl[this.region] || environment.ssoUrl.PT;
    }

    public b2bUrl(): string {
        return environment.b2bUrl[this.region] || environment.b2bUrl.PT;
    }

    public appUrl(): string {
        return environment.appUrl[this.region] || environment.appUrl.PT;
    }

    public url(): string {
        return environment.url[this.region] || environment.url.PT;
    }

    public firebase(): IEnvFirebase {
        return environment.firebase[this.region] || environment.firebase.PT;
    }

    public getCookieDomain(): string {
        return domainCookie[this.region] || domainCookie.PT;
    }

    public getDomain(): string {
        return domain[this.region] || domain.PT;
    }

    public getAnalyticsValue(): string {
        return environment.analyticsValue[this.region];
    }

    public isLocalHost(): boolean{
        return environment.local;
    }
}
